// extracted by mini-css-extract-plugin
module.exports = {"contextPanel":"context-panel_contextPanel__sj3p6"};